import {
  IconCalendarEvent,
  IconCut,
  IconDental,
  IconDots,
  IconSparkles,
  IconStethoscope,
  type TablerIcon,
} from "@tabler/icons-react";

// Phase 79 (UI-SPEC §6b): static category-label lookup — seeded keys resolve
// via the i18n `appointments.categories.*` catalog, unknown clinic-custom
// values fall back to their raw string (never crashes). `t` must be a
// translator scoped to the "appointments" namespace.
const KNOWN_CATEGORY_KEYS = ["klea", "other", "checkup", "hygiene", "treatment", "surgery"];

export function getCategoryLabel(t: (key: string) => string, key: string): string {
  return KNOWN_CATEGORY_KEYS.includes(key) ? t(`categories.${key}`) : key;
}

// Icon-tile category grid (deposit-modal method grid). Known seeded keys get
// a fitting icon; clinic-custom values fall back to the calendar glyph.
export const CATEGORY_ICONS: Record<string, TablerIcon> = {
  checkup: IconStethoscope,
  hygiene: IconSparkles,
  treatment: IconDental,
  surgery: IconCut,
  klea: IconDental,
  other: IconDots,
};

export function categoryIcon(key: string | null | undefined): TablerIcon {
  return (key && CATEGORY_ICONS[key]) || IconCalendarEvent;
}
